import {
  getAuth,
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  sendPasswordResetEmail,
  verifyPasswordResetCode,
  confirmPasswordReset,
  onAuthStateChanged as firebaseOnAuthStateChanged,
} from 'firebase/auth';
import app from './config';
import { detachPushForSignOut } from '../utils/pushNotifications';

const auth = getAuth(app);

export default auth;

export const signIn = (email, password) =>
  signInWithEmailAndPassword(auth, email, password);

// Unlink this device's push subscription from the outgoing account first,
// while still authenticated to call removePushSubscription — otherwise a
// shared device keeps receiving the previous account's notifications.
export const signOut = async () => {
  if (auth.currentUser) await detachPushForSignOut();
  return firebaseSignOut(auth);
};

export const resetPassword = (email) =>
  sendPasswordResetEmail(auth, email);

export const confirmReset = (oobCode, newPassword) =>
  confirmPasswordReset(auth, oobCode, newPassword);

export const checkResetCode = (oobCode) =>
  verifyPasswordResetCode(auth, oobCode);

export const onAuthStateChanged = (callback) =>
  firebaseOnAuthStateChanged(auth, callback);

export const getIdTokenResult = () =>
  auth.currentUser ? auth.currentUser.getIdTokenResult(true) : Promise.resolve(null);
